import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { User } from '@app/_models/user';
import { LazyLoadEvent } from 'primeng/api';
import { TaskService } from '@app/_components/task';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-user-contact',
    templateUrl: './user-contact.component.html',
    styleUrls: ['./user-contact.component.css'],
    standalone: false
})
export class UserContactComponent implements OnInit, OnChanges, AfterViewInit
{

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private taskUserService: UserService,
		private alertService: AlertService,
		private taskService: TaskService,
		private userService: UserService,
		private location: Location,
		private formBuilder: UntypedFormBuilder) { }


	// inputs
	@Output() messageEvent = new EventEmitter<string>();
	@Input() taskApi: any;
	@Input() taskUserRole: number;
	@Input() taskId: number;
	@Input() taskUsers = [];
	@Input() expandAddFormOnCreate: Boolean = false;
	@Input() expandAddFormOnEdit: Boolean = false;
	@Input() title: any;
	@Input() formAction: String;



	// structure
	subscription: Subscription;
	routerLocation = this.location;

	// data
	taskUserApiResponse: ApiResponse;

	// list
	datasource;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	taskUserAddForm: UntypedFormGroup;
	taskUserEditForm: UntypedFormGroup;
	formLoading = false;
	formLabels = [];
	formReadOnly = false;
	taskUserSuggestions: string[];

	// visual
	addFormExpanded: Boolean = false;
	userRoles = [
		{ value: 1, name: 'General', color: '#DCDCDC' },
		{ value: 2, name: 'Employee', color: '#ffcccc' },
		{ value: 3, name: 'Guest', color: '#FFFF99' },
		{ value: 4, name: 'Buyer', color: '#FFFF99' },
		{ value: 5, name: 'Homeowner', color: '#FFFF99' },
		{ value: 6, name: 'Realtor', color: '#FFFF99' },
		{ value: 7, name: 'Developer', color: '#FFFF99' }
	];

	genders = [
		{ value: 'M', name: 'Male' },
		{ value: 'F', name: 'Female' }
	];

	phoneTypes = [
		{ value: 1, name: 'Primary' },
		{ value: 2, name: 'Home' },
		{ value: 3, name: 'Mobile' },
		{ value: 4, name: 'Work' },
		{ value: 5, name: 'Fax' },
		{ value: 6, name: 'Pager' },
		{ value: 7, name: 'Other' },
	];

	emailTypes = [
		{ value: 1, name: 'Primary' },
		{ value: 2, name: 'Home' },
		{ value: 3, name: 'Work' },
		{ value: 4, name: 'Tax' },
		{ value: 5, name: 'Other' },
	];

	addressTypes = [
		{ value: 1, name: 'Business' },
		{ value: 2, name: 'Home' },
		{ value: 3, name: 'Mailing' },
	];

	visibilities = [
		{ value: 1, name: 'Company' },
		{ value: 2, name: 'Team' },
		{ value: 3, name: 'Personal' },
		{ value: 1, name: '' },
		{ value: 4, name: 'Customer/Owner' }
	];

	statuses = [
		{ value: 2, name: 'Proposed' },
		{ value: 0, name: 'Active' },
		{ value: 3, name: 'On Hold' },
		{ value: 1, name: 'Complete' },
		{ value: 4, name: 'Canceled' }
	];

	columns: any[] = [
		{ field: 'userRole', header: 'Role', width: 'auto' },
		{ field: 'user.lastName', header: 'Name', width: 'auto' },
		{ field: 'user.phone', header: 'Phone', width: 'auto' },
		{ field: 'user.email', header: 'Email', width: 'auto' },
		{ field: 'createDate', header: 'Added', width: 'auto' },
	];

	filters: any[] = [
		{ label: 'Created', value: 'createDate' },
		{ label: 'Edited', value: 'lastUpdate' },
		{ label: 'Status', value: 'status' },
		{ label: 'Type', value: 'taskUserType' },
		{ label: 'Visibility', value: 'visibility' },

	];

	// list of countries and states https://gist.github.com/ebaranov/41bf38fdb1a2cb19a781
	countries: any[] =
		[
			{ name: 'Canada', value: 'CA' },
			{ name: 'United States', value: 'US' },
			{ name: '', value: '' },
			{ name: 'Afghanistan', value: 'AF' },
			{ name: 'Aland Islands', value: 'AX' },
			{ name: 'Albania', value: 'AL' },
			{ name: 'Algeria', value: 'DZ' },
			{ name: 'American Samoa', value: 'AS' },
			{ name: 'AndorrA', value: 'AD' },
			{ name: 'Angola', value: 'AO' },
			{ name: 'Anguilla', value: 'AI' },
			{ name: 'Antarctica', value: 'AQ' },
			{ name: 'Antigua and Barbuda', value: 'AG' },
			{ name: 'Argentina', value: 'AR' },
			{ name: 'Armenia', value: 'AM' },
			{ name: 'Aruba', value: 'AW' },
			{ name: 'Australia', value: 'AU' },
			{ name: 'Austria', value: 'AT' },
			{ name: 'Azerbaijan', value: 'AZ' },
			{ name: 'Bahamas', value: 'BS' },
			{ name: 'Bahrain', value: 'BH' },
			{ name: 'Bangladesh', value: 'BD' },
			{ name: 'Barbados', value: 'BB' },
			{ name: 'Belarus', value: 'BY' },
			{ name: 'Belgium', value: 'BE' },
			{ name: 'Belize', value: 'BZ' },
			{ name: 'Benin', value: 'BJ' },
			{ name: 'Bermuda', value: 'BM' },
			{ name: 'Bhutan', value: 'BT' },
			{ name: 'Bolivia', value: 'BO' },
			{ name: 'Bosnia and Herzegovina', value: 'BA' },
			{ name: 'Botswana', value: 'BW' },
			{ name: 'Bouvet Island', value: 'BV' },
			{ name: 'Brazil', value: 'BR' },
			{ name: 'British Indian Ocean Territory', value: 'IO' },
			{ name: 'Brunei Darussalam', value: 'BN' },
			{ name: 'Bulgaria', value: 'BG' },
			{ name: 'Burkina Faso', value: 'BF' },
			{ name: 'Burundi', value: 'BI' },
			{ name: 'Cambodia', value: 'KH' },
			{ name: 'Cameroon', value: 'CM' },

			{ name: 'Cape Verde', value: 'CV' },
			{ name: 'Cayman Islands', value: 'KY' },
			{ name: 'Central African Republic', value: 'CF' },
			{ name: 'Chad', value: 'TD' },
			{ name: 'Chile', value: 'CL' },
			{ name: 'China', value: 'CN' },
			{ name: 'Christmas Island', value: 'CX' },
			{ name: 'Cocos (Keeling) Islands', value: 'CC' },
			{ name: 'Colombia', value: 'CO' },
			{ name: 'Comoros', value: 'KM' },
			{ name: 'Congo', value: 'CG' },
			{ name: 'Congo, The Democratic Republic of the', value: 'CD' },
			{ name: 'Cook Islands', value: 'CK' },
			{ name: 'Costa Rica', value: 'CR' },
			{ name: 'Cote D\'Ivoire', value: 'CI' },
			{ name: 'Croatia', value: 'HR' },
			{ name: 'Cuba', value: 'CU' },
			{ name: 'Cyprus', value: 'CY' },
			{ name: 'Czech Republic', value: 'CZ' },
			{ name: 'Denmark', value: 'DK' },
			{ name: 'Djibouti', value: 'DJ' },
			{ name: 'Dominica', value: 'DM' },
			{ name: 'Dominican Republic', value: 'DO' },
			{ name: 'Ecuador', value: 'EC' },
			{ name: 'Egypt', value: 'EG' },
			{ name: 'El Salvador', value: 'SV' },
			{ name: 'Equatorial Guinea', value: 'GQ' },
			{ name: 'Eritrea', value: 'ER' },
			{ name: 'Estonia', value: 'EE' },
			{ name: 'Ethiopia', value: 'ET' },
			{ name: 'Falkland Islands (Malvinas)', value: 'FK' },
			{ name: 'Faroe Islands', value: 'FO' },
			{ name: 'Fiji', value: 'FJ' },
			{ name: 'Finland', value: 'FI' },
			{ name: 'France', value: 'FR' },
			{ name: 'French Guiana', value: 'GF' },
			{ name: 'French Polynesia', value: 'PF' },
			{ name: 'French Southern Territories', value: 'TF' },
			{ name: 'Gabon', value: 'GA' },
			{ name: 'Gambia', value: 'GM' },
			{ name: 'Georgia', value: 'GE' },
			{ name: 'Germany', value: 'DE' },
			{ name: 'Ghana', value: 'GH' },
			{ name: 'Gibraltar', value: 'GI' },
			{ name: 'Greece', value: 'GR' },
			{ name: 'Greenland', value: 'GL' },
			{ name: 'Grenada', value: 'GD' },
			{ name: 'Guadeloupe', value: 'GP' },
			{ name: 'Guam', value: 'GU' },
			{ name: 'Guatemala', value: 'GT' },
			{ name: 'Guernsey', value: 'GG' },
			{ name: 'Guinea', value: 'GN' },
			{ name: 'Guinea-Bissau', value: 'GW' },
			{ name: 'Guyana', value: 'GY' },
			{ name: 'Haiti', value: 'HT' },
			{ name: 'Heard Island and Mcdonald Islands', value: 'HM' },
			{ name: 'Holy See (Vatican City State)', value: 'VA' },
			{ name: 'Honduras', value: 'HN' },
			{ name: 'Hong Kong', value: 'HK' },
			{ name: 'Hungary', value: 'HU' },
			{ name: 'Iceland', value: 'IS' },
			{ name: 'India', value: 'IN' },
			{ name: 'Indonesia', value: 'ID' },
			{ name: 'Iran, Islamic Republic Of', value: 'IR' },
			{ name: 'Iraq', value: 'IQ' },
			{ name: 'Ireland', value: 'IE' },
			{ name: 'Isle of Man', value: 'IM' },
			{ name: 'Israel', value: 'IL' },
			{ name: 'Italy', value: 'IT' },
			{ name: 'Jamaica', value: 'JM' },
			{ name: 'Japan', value: 'JP' },
			{ name: 'Jersey', value: 'JE' },
			{ name: 'Jordan', value: 'JO' },
			{ name: 'Kazakhstan', value: 'KZ' },
			{ name: 'Kenya', value: 'KE' },
			{ name: 'Kiribati', value: 'KI' },
			{ name: 'Korea, Democratic People\'S Republic of', value: 'KP' },
			{ name: 'Korea, Republic of', value: 'KR' },
			{ name: 'Kuwait', value: 'KW' },
			{ name: 'Kyrgyzstan', value: 'KG' },
			{ name: 'Lao People\'S Democratic Republic', value: 'LA' },
			{ name: 'Latvia', value: 'LV' },
			{ name: 'Lebanon', value: 'LB' },
			{ name: 'Lesotho', value: 'LS' },
			{ name: 'Liberia', value: 'LR' },
			{ name: 'Libyan Arab Jamahiriya', value: 'LY' },
			{ name: 'Liechtenstein', value: 'LI' },
			{ name: 'Lithuania', value: 'LT' },
			{ name: 'Luxembourg', value: 'LU' },
			{ name: 'Macao', value: 'MO' },
			{ name: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
			{ name: 'Madagascar', value: 'MG' },
			{ name: 'Malawi', value: 'MW' },
			{ name: 'Malaysia', value: 'MY' },
			{ name: 'Maldives', value: 'MV' },
			{ name: 'Mali', value: 'ML' },
			{ name: 'Malta', value: 'MT' },
			{ name: 'Marshall Islands', value: 'MH' },
			{ name: 'Martinique', value: 'MQ' },
			{ name: 'Mauritania', value: 'MR' },
			{ name: 'Mauritius', value: 'MU' },
			{ name: 'Mayotte', value: 'YT' },
			{ name: 'Mexico', value: 'MX' },
			{ name: 'Micronesia, Federated States of', value: 'FM' },
			{ name: 'Moldova, Republic of', value: 'MD' },
			{ name: 'Monaco', value: 'MC' },
			{ name: 'Mongolia', value: 'MN' },
			{ name: 'Montserrat', value: 'MS' },
			{ name: 'Morocco', value: 'MA' },
			{ name: 'Mozambique', value: 'MZ' },
			{ name: 'Myanmar', value: 'MM' },
			{ name: 'Namibia', value: 'NA' },
			{ name: 'Nauru', value: 'NR' },
			{ name: 'Nepal', value: 'NP' },
			{ name: 'Netherlands', value: 'NL' },
			{ name: 'Netherlands Antilles', value: 'AN' },
			{ name: 'New Caledonia', value: 'NC' },
			{ name: 'New Zealand', value: 'NZ' },
			{ name: 'Nicaragua', value: 'NI' },
			{ name: 'Niger', value: 'NE' },
			{ name: 'Nigeria', value: 'NG' },
			{ name: 'Niue', value: 'NU' },
			{ name: 'Norfolk Island', value: 'NF' },
			{ name: 'Northern Mariana Islands', value: 'MP' },
			{ name: 'Norway', value: 'NO' },
			{ name: 'Oman', value: 'OM' },
			{ name: 'Pakistan', value: 'PK' },
			{ name: 'Palau', value: 'PW' },
			{ name: 'Palestinian Territory, Occupied', value: 'PS' },
			{ name: 'Panama', value: 'PA' },
			{ name: 'Papua New Guinea', value: 'PG' },
			{ name: 'Paraguay', value: 'PY' },
			{ name: 'Peru', value: 'PE' },
			{ name: 'Philippines', value: 'PH' },
			{ name: 'Pitcairn', value: 'PN' },
			{ name: 'Poland', value: 'PL' },
			{ name: 'Portugal', value: 'PT' },
			{ name: 'Puerto Rico', value: 'PR' },
			{ name: 'Qatar', value: 'QA' },
			{ name: 'Reunion', value: 'RE' },
			{ name: 'Romania', value: 'RO' },
			{ name: 'Russian Federation', value: 'RU' },
			{ name: 'RWANDA', value: 'RW' },
			{ name: 'Saint Helena', value: 'SH' },
			{ name: 'Saint Kitts and Nevis', value: 'KN' },
			{ name: 'Saint Lucia', value: 'LC' },
			{ name: 'Saint Pierre and Miquelon', value: 'PM' },
			{ name: 'Saint Vincent and the Grenadines', value: 'VC' },
			{ name: 'Samoa', value: 'WS' },
			{ name: 'San Marino', value: 'SM' },
			{ name: 'Sao Tome and Principe', value: 'ST' },
			{ name: 'Saudi Arabia', value: 'SA' },
			{ name: 'Senegal', value: 'SN' },
			{ name: 'Serbia and Montenegro', value: 'CS' },
			{ name: 'Seychelles', value: 'SC' },
			{ name: 'Sierra Leone', value: 'SL' },
			{ name: 'Singapore', value: 'SG' },
			{ name: 'Slovakia', value: 'SK' },
			{ name: 'Slovenia', value: 'SI' },
			{ name: 'Solomon Islands', value: 'SB' },
			{ name: 'Somalia', value: 'SO' },
			{ name: 'South Africa', value: 'ZA' },
			{ name: 'South Georgia and the South Sandwich Islands', value: 'GS' },
			{ name: 'Spain', value: 'ES' },
			{ name: 'Sri Lanka', value: 'LK' },
			{ name: 'Sudan', value: 'SD' },
			{ name: 'Suriname', value: 'SR' },
			{ name: 'Svalbard and Jan Mayen', value: 'SJ' },
			{ name: 'Swaziland', value: 'SZ' },
			{ name: 'Sweden', value: 'SE' },
			{ name: 'Switzerland', value: 'CH' },
			{ name: 'Syrian Arab Republic', value: 'SY' },
			{ name: 'Taiwan, Province of China', value: 'TW' },
			{ name: 'Tajikistan', value: 'TJ' },
			{ name: 'Tanzania, United Republic of', value: 'TZ' },
			{ name: 'Thailand', value: 'TH' },
			{ name: 'Timor-Leste', value: 'TL' },
			{ name: 'Togo', value: 'TG' },
			{ name: 'Tokelau', value: 'TK' },
			{ name: 'Tonga', value: 'TO' },
			{ name: 'Trinidad and Tobago', value: 'TT' },
			{ name: 'Tunisia', value: 'TN' },
			{ name: 'Turkey', value: 'TR' },
			{ name: 'Turkmenistan', value: 'TM' },
			{ name: 'Turks and Caicos Islands', value: 'TC' },
			{ name: 'Tuvalu', value: 'TV' },
			{ name: 'Uganda', value: 'UG' },
			{ name: 'Ukraine', value: 'UA' },
			{ name: 'United Arab Emirates', value: 'AE' },
			{ name: 'United Kingdom', value: 'GB' },

			{ name: 'United States Minor Outlying Islands', value: 'UM' },
			{ name: 'Uruguay', value: 'UY' },
			{ name: 'Uzbekistan', value: 'UZ' },
			{ name: 'Vanuatu', value: 'VU' },
			{ name: 'Venezuela', value: 'VE' },
			{ name: 'Viet Nam', value: 'VN' },
			{ name: 'Virgin Islands, British', value: 'VG' },
			{ name: 'Virgin Islands, U.S.', value: 'VI' },
			{ name: 'Wallis and Futuna', value: 'WF' },
			{ name: 'Western Sahara', value: 'EH' },
			{ name: 'Yemen', value: 'YE' },
			{ name: 'Zambia', value: 'ZM' },
			{ name: 'Zimbabwe', value: 'ZW' }
		];

	// validation
	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'taskId': [],
		'userId': [],
		'createDate': [],
		'status': [],

		// name
		'firstName': [],
		'middleName': [],
		'lastName': [],
		'suffix': [],
		'companyName': [],

		// role
		'title': [],
		'role': [],
		'userRole': [],

		// email
		'email': [],
		'emailType': [],
		'email2': [],
		'email2Type': [],
		'email3': [],
		'email3Type': [],
		'email4': [],
		'email4Type': [],

		// phones
		'phone': [],
		'phoneType': [],
		'phone2': [],
		'phone2Type': [],
		'phone3': [],
		'phone3Type': [],
		'phone4': [],
		'phone4Type': [],
		'phone5': [],
		'phone5Type': [],
		'phone6': [],
		'phone6Type': [],
		'phone7': [],
		'phone7Type': [],
		'phone8': [],
		'phone8Type': [],
		// address
		'adrType': [],
		'adrStreet': [],
		'adrStreet2': [],
		'adrCity': [],
		'adrState': [],
		'adrPostalCode': [],
		'adrCountry': [],

		// address
		'adr2Type': [],
		'adr2AddressType': [],
		'adr2Street': [],
		'adr2Street2': [],
		'adr2City': [],
		'adr2State': [],
		'adr2PostalCode': [],
		'adr2Country': [],

		// id
		'iMID': [],
		'iMService': [],

		// tax
		'taxID': [],
		'sSN': [],

		// bio
		'website': [],
		'pictureURL': [],
		'anniversary': [], // use for picture
		'birthday': [],
		'birthdate': [],
		'children': [],
		'gender': [],
		'language': [],
		'notes': []
	};



	ngOnInit()
	{
		try
		{
			if (!this.title) { this.title = 'Contact'; }
			if (this.taskApi)
			{
				if (!this.taskId) { this.taskId = this.taskApi.taskId; }
				this.taskUsers = (this.taskApi.taskUsers ? this.taskApi.taskUsers : []);
			}

			this.buildAddForm();
			this.buildEditForm();

			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error)
		{
			console.log('Error: ' + error);
		}
	}

	ngAfterViewInit()
	{
		this.initializeViewPreferences();
	}

	formAdd()
	{
		console.log('trying to add: ');
		try
		{
			// stop here if form is invalid
			if (this.taskUserAddForm.invalid)
			{
				return;
			}

			this.formLoading = true;

			// use the .pipe(take(1)) to prevent double firing...
			this.taskService.addTaskUserContact(this.taskUserAddForm.value).pipe(take(1))
				.subscribe(
					res =>
					{
						console.log('User-Add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.taskUsers.unshift(res.data.taskUser);
						this.buildAddForm();
					},
					err =>
					{
						console.log('User-Add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			console.log('Form Submitted: ' + JSON.stringify(this.taskUserEditForm.value));
			if (this.taskUserEditForm.invalid)
			{
				console.log('Form Invalid: ' + JSON.stringify(this.taskUserEditForm.getError));
				return;
			}

			this.formLoading = true;
			this.taskService.updateTaskUserContact(this.taskUserEditForm.value)
				.subscribe(
					res =>
					{
						console.log('User-Update SUCCESS: ' + JSON.stringify(res));
						this.taskUsers.map((taskUser, i) =>
						{
							if (taskUser.userId === res.data.taskUser.userId)
							{
								this.taskUsers[i] = res.data.taskUser;
							}
						});
						this.alertService.success(res, true);
					},
					err =>
					{
						console.log('User-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete(taskUser)
	{
		try
		{
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(taskUser));
			if (this.taskUserEditForm.invalid)
			{
				console.log('Form Invalid: ' + JSON.stringify(this.taskUserEditForm.getError));
				return;
			}

			this.formLoading = true;
			this.taskService.deleteTaskUser(this.taskUserEditForm.value)
				.subscribe(
					res =>
					{
						console.log('deleteTaskUser SUCCESS: ' + JSON.stringify(res));
						this.taskUsers.splice(this.taskUsers.indexOf(taskUser), 1);
						this.recordTotal = this.taskUsers.length;
						this.alertService.success(res, true);
					},
					err =>
					{
						console.log('User-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	loadLazy(event: LazyLoadEvent)
	{

		this.lazyLoadEvent = event;
		const pageNumber = Math.round(event.first / event.rows);
		console.log(
			' event.first:' + event.first
			+ '  |  event.rows:' + event.rows
			+ '  |  event.sortField:' + event.sortField
			+ '  |  event.sortOrder:' + event.sortOrder
			+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
			+ '  |  event.globalFilter:' + event.globalFilter
			+ '  |  event.filters:' + JSON.stringify(event.filters)
		);

		// if empty (ie when parent is in 'add' and we dont' have a sourceId yet), do nothing
		if (this.taskId == null)
		{
			setTimeout(() =>
			{
				// we have to wait a second as the table is still loading to prevent a ExpressionChangedAfterItHasBeenCheckedError
				this.loading = false;
			}, 1);
			return;
		}

		this.taskService.findTaskUsers(
			pageNumber, event.rows,
			event.sortField,
			event.sortOrder,
			event.multiSortMeta,
			event.globalFilter,
			event.filters,
			this.taskId).pipe(first()).subscribe(

				res =>
				{
					console.log('taskUsers are: ' + JSON.stringify(res));
					this.datasource = res.data.taskUsers;
					this.taskUsers = res.data.taskUsers;
					this.recordTotal = res.page.recordTotal;
				},
				error =>
				{
					console.log('USER LIST!: ' + JSON.stringify(error));
					this.alertService.error(error);
				},
				() =>
				{ this.loading = false; }
			);

		try
		{
			if (this.datasource)
			{
				this.taskUsers = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	sortList(event)
	{
		console.log('formTest', event);
		this.multiSortMeta = [];
		this.multiSortMeta.push({ field: event.value.value, order: 0 });
		this.lazyLoadEvent.multiSortMeta = this.multiSortMeta;
		this.loadLazy(this.lazyLoadEvent);
	}

	updateToUserList(event)
	{
		console.log('updateUserList', event);
		this.taskUsers.map((taskUser, i) =>
		{
			if (taskUser.userId === event.userId)
			{
				this.taskUsers[i] = event;
			}
		});
	}


	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.taskUserAddForm !== undefined)
		{
			this.taskUserAddForm.patchValue({ taskId: this.taskId });
		}
	}


	buildAddForm()
	{

		this.taskUserAddForm = this.formBuilder.group({
			userId: [],
			taskId: [this.taskId],

			user: this.formBuilder.group({
				existingUserSelect: [],
				userId: [],
				createDate: [],
				status: [],

				// name
				firstName: [],
				middleName: [],
				lastName: [],
				suffix: [],
				companyName: [],

				// role
				title: [],
				role: [],
				userRole: [],

				// email
				email: [],
				emailType: [],
				email2: [],
				email2Type: [],
				email3: [],
				email3Type: [],
				email4: [],
				email4Type: [],

				// phones
				phone: [],
				phoneType: [],
				phone2: [],
				phone2Type: [],
				phone3: [],
				phone3Type: [],
				phone4: [],
				phone4Type: [],
				phone5: [],
				phone5Type: [],
				phone6: [],
				phone6Type: [],
				phone7: [],
				phone7Type: [],
				phone8: [],
				phone8Type: [],
				// address
				adrType: [],
				adrStreet: [],
				adrStreet2: [],
				adrCity: [],
				adrState: [],
				adrPostalCode: [],
				adrCountry: [],

				// address
				adr2Type: [],
				adr2AddressType: [],
				adr2Street: [],
				adr2Street2: [],
				adr2City: [],
				adr2State: [],
				adr2PostalCode: [],
				adr2Country: [],

				// id
				iMID: [],
				iMService: [],

				// tax
				taxID: [],
				sSN: [],

				// bio
				website: [],
				pictureURL: [],
				anniversary: [], // use for picture
				birthday: [],
				birthdate: [],
				children: [],
				gender: [],
				language: [],
				notes: []
			})
		});
	}

	buildEditForm()
	{

		this.taskUserEditForm = this.formBuilder.group({
			userId: [],
			taskId: [this.taskId],
			demoArray: this.formBuilder.array([]),
			user: this.formBuilder.group({


				userId: [],
				createDate: [],
				status: [],

				// name
				firstName: [],
				middleName: [],
				lastName: [],
				suffix: [],
				companyName: [],

				// role
				title: [],
				role: [],
				userRole: [],

				// email
				email: [],
				emailType: [],
				email2: [],
				email2Type: [],
				email3: [],
				email3Type: [],
				email4: [],
				email4Type: [],

				// phones
				phone: [],
				phoneType: [],
				phone2: [],
				phone2Type: [],
				phone3: [],
				phone3Type: [],
				phone4: [],
				phone4Type: [],
				phone5: [],
				phone5Type: [],
				phone6: [],
				phone6Type: [],
				phone7: [],
				phone7Type: [],
				phone8: [],
				phone8Type: [],

				// address
				adrType: [],
				adrStreet: [],
				adrStreet2: [],
				adrCity: [],
				adrState: [],
				adrPostalCode: [],
				adrCountry: [],

				// address
				adr2Type: [],
				adr2AddressType: [],
				adr2Street: [],
				adr2Street2: [],
				adr2City: [],
				adr2State: [],
				adr2PostalCode: [],
				adr2Country: [],

				// id
				iMID: [],
				iMService: [],

				// tax
				taxID: [],
				sSN: [],

				// bio
				website: [],
				pictureURL: [],
				anniversary: [], // use for picture
				birthday: [],
				birthdate: [],
				children: [],
				gender: [],
				language: [],
				notes: []
			})
		});
	}

	patchUser(taskUser)
	{
		this.taskUserEditForm.patchValue(taskUser);
	}

	/*
    *
    *
    *  ADD CONTACT
    *
    */

	/* Search for user */
	findUsersWith(queryString: string)
	{
		this.taskUserService.findUsersWith(queryString).pipe(first()).subscribe(

			data =>
			{
				console.log('taskUser serach: ' + JSON.stringify(data));
				this.taskUserSuggestions = [];
				this.taskUserSuggestions = data.data.userSummaryList;
				// console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	/* On each keystroke search for the user */
	onKeyInput(event)
	{
		let query = event.query;
		this.findUsersWith(query);
		return this.taskUserSuggestions;
	}

	/* When the user is found in the autocomplete search, add them to the taskUser table */
	onSelect(event)
	{
		if (this.taskId == null)
		{
			this.alertService.error('Please enter a task name first');
		}
		else
		{
			// assemble the payload manually since we are using primeng
			console.log('onSelect: ' + JSON.stringify(event));
			let data: any = {};
			data.taskId = this.taskId;
			data.userId = event.userId;
			console.log('onSelect: ' + JSON.stringify(data));
			this.addTaskUser(data);
			this.buildAddForm();
		}
	}


	addTaskUser(taskUser)
	{
		this.taskService.addTaskUserContact(taskUser).pipe(first()).subscribe(
			res =>
			{
				this.alertService.success(res, true);
				this.taskUsers.unshift(res.data.taskUser);
				console.log('BOOM: ' + JSON.stringify(res.data.taskUser));

			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}
	findTaskUser(taskId, userId)
	{
		this.taskService.findTaskUser(taskId, userId).pipe(first()).subscribe(
			data =>
			{
				this.alertService.success(data, true);
				console.log('BOOM: ' + JSON.stringify(data.data.taskUser));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	deleteTaskUser(taskUser)
	{
		this.taskService.deleteTaskUser(taskUser).pipe(first()).subscribe(

			data =>
			{
				// console.log('deleteTaskUser are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}


	addUserContact(user)
	{

		if (this.taskUserAddForm.invalid)
		{
			console.log('Form Invalid: ' + JSON.stringify(this.taskUserAddForm.getError));
			return;
		}

		this.formLoading = true;

		// first add contact
		this.userService.addUserContact(this.taskUserAddForm.value).pipe(first()).subscribe(

			data =>
			{
				console.log('addUserContact: ' + JSON.stringify(data));
				let taskUser: any = {};
				taskUser.taskId = this.taskId;
				taskUser.userId = data.data.userContact.userId;
				this.addTaskUser(taskUser);
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);

		// next add contact to userTask


	}

	updateUserContact(user)
	{
		this.userService.updateUserContact(user).pipe(first()).subscribe(

			data =>
			{
				// console.log('updateUserContact are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}
	displayPaginator()
	{
		return this.taskUsers && this.taskUsers.length > 25 ? true : false;
	}

	initializeViewPreferences()
	{
		if (this.formAction = 'add')
		{
			console.log('ADD 1 ' + this.formAction + ' ' + this.expandAddFormOnCreate + ' ' + this.addFormExpanded);
			if (this.expandAddFormOnCreate)
			{
				this.addFormExpanded = true;
				console.log('ADD 2 ' + this.formAction + ' ' + this.expandAddFormOnCreate + ' ' + this.addFormExpanded);
			}
			else
			{
				console.log('ADD 3 ' + this.formAction + ' ' + this.expandAddFormOnCreate + ' ' + this.addFormExpanded);
				this.addFormExpanded = false;
			}
		}

		if (this.formAction = 'edit')
		{
			if (this.expandAddFormOnEdit)
			{
				this.addFormExpanded = true;
			}
			else
			{
				this.addFormExpanded = false;
			}
		}
	}

}
